import {
  FETCH_ACTIVE_JOBS_COUNT,
  FETCH_ACTIVE_CLIENTS_COUNT,
  FETCH_TOTAL_REVENUE,
  FETCH_WEBSHOP_ORDERS_COUNT,
  FETCH_CALENDAR_JOBS,
  RESET_DASHBOARD
} from '../actions/dashboardActions';

const mapPayloadToMetric = (payload) => {
  if (payload && typeof payload === 'object' && 'current' in payload && 'previous' in payload) {
    return {
      current: Number(payload.current) || 0,
      previous: Number(payload.previous) || 0,
      period: payload.period || null
    };
  }

  const numericValue = Number(payload) || 0;
  return {
    current: numericValue,
    previous: 0,
    period: null
  };
};

const initialState = {
  metrics: {
    activeJobs: { current: 0, previous: 0, period: null },
    activeClients: { current: 0, previous: 0, period: null },
    totalRevenue: { current: 0, previous: 0, period: null },
    webshopOrders: { current: 0, previous: 0, period: null }
  },
  calendarJobs: [],
  loading: true,
  error: null
};

const dashboardReducer = (state = initialState, action) => {
  if (action.type === 'auth/setLogout' || action.type === 'auth/login/fulfilled') {
    return { ...initialState };
  }

  switch (action.type) {
    case FETCH_ACTIVE_JOBS_COUNT:
      return {
        ...state,
        metrics: {
          ...state.metrics,
          activeJobs: mapPayloadToMetric(action.payload)
        },
        loading: false,
        error: null
      };

    case FETCH_ACTIVE_CLIENTS_COUNT:
      return {
        ...state,
        metrics: {
          ...state.metrics,
          activeClients: mapPayloadToMetric(action.payload)
        },
        loading: false,
        error: null
      };

    case FETCH_TOTAL_REVENUE:
      return {
        ...state,
        metrics: {
          ...state.metrics,
          totalRevenue: mapPayloadToMetric(action.payload)
        },
        loading: false,
        error: null
      };

    case FETCH_WEBSHOP_ORDERS_COUNT:
      return {
        ...state,
        metrics: {
          ...state.metrics,
          webshopOrders: mapPayloadToMetric(action.payload)
        },
        loading: false,
        error: null
      };

    case FETCH_CALENDAR_JOBS:
      return {
        ...state,
        calendarJobs: Array.isArray(action.payload) ? action.payload : [],
        loading: false,
        error: null
      };

    case RESET_DASHBOARD:
      return { ...initialState };

    default:
      return state;
  }
};

export default dashboardReducer;